import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GhostAddToCartModule } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-add-to-cart/ghost-add-to-cart.module';
import { GhostParagraphModule } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-paragraph/ghost-paragraph.module';
import { GhostProductCardComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-product-card/ghost-product-card.component';
import { GhostProductMediaModule } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-product-media/ghost-product-media.module';
import { GhostTitleModule } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-title/ghost-title.module';

@NgModule({
  declarations: [GhostProductCardComponent],
  imports: [
    CommonModule,
    GhostProductMediaModule,
    GhostTitleModule,
    GhostParagraphModule,
    GhostAddToCartModule,
  ],
  exports: [GhostProductCardComponent],
})
export class GhostProductListingModule {}
